import React, { FormHTMLAttributes } from "react";

export function EnterKeyCatcher(props: {
  handleSubmit: FormHTMLAttributes<HTMLFormElement>["onSubmit"];
  children: React.ReactNode;
}) {
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        props.handleSubmit?.(e);
      }}
    >
      <button type="submit" className="invisible-button" />
      {props.children}
    </form>
  );
}
